import "./reservationcard.css"
import React from 'react'
import { useTranslation } from 'react-i18next';

export default function Reservationcard({remboursement}) {
  const { t } = useTranslation();
  return (
    <div className="Reservationcard">
        <div className="row">
          <p className={remboursement ? "remboursable" : "non_remboursable"}>
            {remboursement ? t("vols.results.refundable") : t("vols.results.non_refundable")}
          </p>
          <p className="price">12 000 {t("vols.results.currency")}</p>
        </div>
        <button><p>{t("vols.results.book")}</p></button>
    </div>
  )
}
